module.exports = __webpack_public_path__ + "assets/img/background-vehicleInfo.788de37e.png";